var map = {
	"./AssistSlicer/AssistSlicerPreview.vue": "2466",
	"./AssistSlicer/index.js": "c01b",
	"./ContactCustomerService/ContactCustomerServicePreview.vue": "9007",
	"./ContactCustomerService/index.js": "37fa",
	"./Goods/GoodsPreview.vue": "8a06",
	"./Goods/GoodsSettingCustomBadgeStyle.vue": "a612",
	"./Goods/GoodsSettingCustomBuyBtn.vue": "d2e0",
	"./Goods/GoodsSettingSelector.vue": "d334",
	"./Goods/index.js": "e681",
	"./GoodsSearch/GoodsSearchPreview.vue": "38e0",
	"./GoodsSearch/index.js": "f98a",
	"./ImageAdv/ImageAdvPreview.vue": "7c52",
	"./ImageAdv/ImageAdvSelector.vue": "90bb",
	"./ImageAdv/index.js": "6cf1",
	"./ImageTextNav/ImageTextNavPreview.vue": "fe77",
	"./ImageTextNav/ImageTextNavSelector.vue": "3d43",
	"./ImageTextNav/index.js": "6d63",
	"./MagicCube/MagicCubeBlocks.vue": "0946",
	"./MagicCube/MagicCubePreview.vue": "a79a",
	"./MagicCube/index.js": "c374",
	"./MagicCube/mixin.js": "0cf3",
	"./NoticeBar/NoticeBarPreview.vue": "16b9",
	"./NoticeBar/index.js": "b3a4",
	"./PersonalizedRecom/PersonalizedRecomPreview.vue": "dc8d",
	"./PersonalizedRecom/goodsSelect.vue": "b420",
	"./PersonalizedRecom/index.js": "b162",
	"./Reservation/ReservationPreview.vue": "db55",
	"./Reservation/SeckillGoodsSelect.vue": "45f3",
	"./Reservation/index.js": "5ebd",
	"./RichText/RichTextEditor.vue": "ebd9",
	"./RichText/RichTextPreview.vue": "a568",
	"./RichText/index1.js": "fdd52",
	"./Seckill/SeckilPreview.vue": "629a",
	"./Seckill/index1.js": "fa75",
	"./ShopCoupon/ShopCouponPreview.vue": "322c",
	"./ShopCoupon/index1.js": "ed18",
	"./ShopInfo/BackgroundImage.vue": "0580",
	"./ShopInfo/ShopInfoBackgroundImage.vue": "50d7",
	"./ShopInfo/ShopInfoPreview.vue": "ebd6",
	"./ShopInfo/ShopInfoSelector.vue": "e51c",
	"./ShopInfo/ShopTagSelector.vue": "5087",
	"./ShopInfo/index1.js": "c101",
	"./Tabs/TabsAdvSelector.vue": "0ad9",
	"./Tabs/index1.js": "5b85",
	"./Tabs/tabsPreview.vue": "921d",
	"./TabsAdv/TabsAdvPreview.vue": "3af7",
	"./TabsAdv/TabsAdvSelector.vue": "e01d",
	"./TabsAdv/index1.js": "a2bf",
	"./TitleText/TitleTextMoreStyle.vue": "2ddd",
	"./TitleText/TitleTextPreview.vue": "2b5c",
	"./TitleText/index.js": "7f53",
	"./ToShop/ToShopPreview.vue": "c554",
	"./ToShop/ToShopSelector.vue": "fdd5",
	"./ToShop/index1.js": "b7a7",
	"./VideoModule/VideoModulePreview.vue": "b1cf",
	"./VideoModule/VideoModuleSetting.vue": "5e21",
	"./VideoModule/index.js": "6a2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6c5";